module.exports = __webpack_public_path__ + "HritamSamanta-cc7af676.webp";